<div class="flex flex-col bg-card overflow-hidden height-100p">
  <div class="files-panel">
    <div
      class="pl-3 pr-3 pt-2 pb-2 border-b flex items-center"
      appAccountColorBackground
      #backgroundDirective="appAccountColorBackground"
      [colorName]="panelDef?.color"
    >
      <div class="flex items-center flex-auto" *ngIf="changeTitleMode">
        <app-form-field [fieldDef]="titleFieldDef" [model]="project" (onUpdate)="update($event)"></app-form-field>
      </div>
      <div class="flex flex-col">
        <div
          *ngIf="!changeTitleMode"
          class="font-bold text-md text-secondary uppercase tracking-wider"
          [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
        >
          {{ panelDef.title }}
        </div>
      </div>
      <div class="ml-auto">
        <input style="display: none" type="file" (change)="onFileChanged($event)" #fileInput />
        <button
          *ngIf="!readonly && !changeTitleMode"
          mat-icon-button
          (click)="fileInput.click()"
          [matTooltip]="'Upload File'"
        >
          <mat-icon
            [svgIcon]="'publish'"
            [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
          ></mat-icon>
        </button>
        <ng-container *ngIf="canEditPanelDef">
          <button mat-icon-button type="button" *ngIf="!changeTitleMode" [matMenuTriggerFor]="listCard09Menu">
            <mat-icon
              class="icon-size-20"
              [svgIcon]="'more_vert'"
              [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
            ></mat-icon>
          </button>
          <mat-menu #listCard09Menu="matMenu">
            <button mat-menu-item (click)="toggleChangeTitleMode()" type="button">
              <mat-icon [svgIcon]="'edit'"></mat-icon>
              Change Panel Heading
            </button>
            <button mat-menu-item [matMenuTriggerFor]="toggleLabelMenu" type="button">
              <mat-icon [svgIcon]="'color_lens'"></mat-icon>
              Heading Color
            </button>
            <mat-menu class="mailbox-details-toggle-label-menu-panel" #toggleLabelMenu="matMenu">
              <div
                mat-menu-item
                class="gap-2"
                *ngFor="let color of accountColors$ | async"
                (click)="selectHeaderColor(color.name)"
              >
                <ts-color-bubble [hexColor]="color.hex_value"></ts-color-bubble>
                {{ color.label }}
              </div>
            </mat-menu>
          </mat-menu>
          <button
            class="cancel-button"
            mat-icon-button
            type="button"
            *ngIf="changeTitleMode"
            [matTooltip]="'Cancel'"
            (click)="toggleEditMode(false)"
          >
            <mat-icon
              [svgIcon]="'cancel'"
              [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
            ></mat-icon>
          </button>
          <button mat-icon-button *ngIf="changeTitleMode" type="submit" (click)="saveLayout()" [matTooltip]="'Save'">
            <mat-icon
              [svgIcon]="'save'"
              [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
            ></mat-icon>
          </button>
        </ng-container>
      </div>
    </div>

    <!-- Loading Bar -->
    <ng-container *ngIf="isLoading">
      <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>
    </ng-container>

    <div class="flex flex-col files-panel__body">
      <ng-container *ngIf="files?.length; else emptyFiles">
        @if (newTable) {
          <ts-table [columnDefs]="columnDefs" [rowData]="files" [actions]="actions"> </ts-table>
          <button
            class="px-3 border-none text-right"
            style="margin-left: 0 auto"
            *ngIf="!readonly"
            mat-stroked-button
            [color]="'primary'"
            [routerLink]="['/projects', project?.pipeline_id, project?.id, 'folders']"
          >
            See all files
          </button>
        } @else {
          <table class="w-full bg-transparent" mat-table matSort [dataSource]="files" [trackBy]="trackByFn">
            <!-- Name -->
            <ng-container matColumnDef="name">
              <th
                class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t"
                mat-header-cell
                mat-sort-header
                *matHeaderCellDef
              >
                <span class="whitespace-nowrap">Name</span>
              </th>
              <td mat-cell *matCellDef="let file">
                <span class="pr-6 whitespace-nowrap">
                  <a (click)="viewFile(file)" class="pointer">{{ file.name }}</a>
                </span>
              </td>
            </ng-container>

            <!-- Created -->
            <ng-container matColumnDef="created">
              <th
                class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t"
                mat-header-cell
                mat-sort-header
                *matHeaderCellDef
              >
                <span class="whitespace-nowrap">Created</span>
              </th>
              <td mat-cell *matCellDef="let file">
                <span class="pr-6 whitespace-nowrap">
                  {{ file.created_at | date: 'LLL dd, y' }}
                </span>
              </td>
            </ng-container>

            <!-- Footer -->
            <ng-container matColumnDef="filesTableFooter">
              <td class="px-3 border-none text-right" mat-footer-cell *matFooterCellDef colspan="6">
                <button
                  *ngIf="!readonly"
                  mat-stroked-button
                  [color]="'primary'"
                  [routerLink]="['/projects', project?.pipeline_id, project?.id, 'folders']"
                >
                  See all files
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
            <tr class="order-row h-16" mat-row *matRowDef="let row; columns: displayColumns"></tr>
            <tr class="h-16" mat-footer-row *matFooterRowDef="['filesTableFooter']"></tr>
          </table>
        }
      </ng-container>
    </div>
  </div>
</div>

<ng-template #emptyFiles>
  <div class="flex flex-col items-center justify-center h-full p-8">
    <mat-icon class="icon-size-40" [svgIcon]="'folder'"></mat-icon>
    <p class="text-2xl text-secondary font-medium mt-4">No files found</p>
    <p class="text-sm text-secondary mt-2">Add files to this panel to associate them with this deal.</p>
  </div>
</ng-template>
